var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6829_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9801 29.4844C36.4529 29.4844 34.4019 27.4167 34.4019 24.869C34.4019 22.3213 36.4529 20.2536 38.9801 20.2536C41.5073 20.2536 43.5583 22.3213 43.5583 24.869C43.5583 27.4167 41.5073 29.4844 38.9801 29.4844ZM38.9801 27.5767C40.4634 27.5767 41.666 26.3644 41.666 24.869C41.666 23.3736 40.4634 22.1613 38.9801 22.1613C37.4968 22.1613 36.2942 23.3736 36.2942 24.869C36.2942 26.3644 37.4968 27.5767 38.9801 27.5767ZM29.3963 29.4844C26.8692 29.4844 24.8181 27.4167 24.8181 24.869C24.8181 22.3213 26.8692 20.2536 29.3963 20.2536C31.9235 20.2536 33.9746 22.3213 33.9746 24.869C33.9746 27.4167 31.9235 29.4844 29.3963 29.4844ZM29.3963 27.5767C30.8797 27.5767 32.0822 26.3644 32.0822 24.869C32.0822 23.3736 30.8797 22.1613 29.3963 22.1613C27.913 22.1613 26.7105 23.3736 26.7105 24.869C26.7105 26.3644 27.913 27.5767 29.3963 27.5767ZM24.3908 24.8075C24.3908 27.3859 22.3398 29.4844 19.8126 29.4844C17.2854 29.4844 15.2344 27.3921 15.2344 24.8136C15.2344 22.2352 17.0962 20.2536 19.8126 20.2536C20.8137 20.2536 21.7416 20.469 22.4985 21.029V18.3521C22.4985 17.8413 22.9441 17.4229 23.4447 17.4229C23.9452 17.4229 24.3908 17.8413 24.3908 18.3521V24.8075ZM19.8126 27.5767C21.2959 27.5767 22.4985 26.3644 22.4985 24.869C22.4985 23.3736 21.2959 22.1613 19.8126 22.1613C18.3293 22.1613 17.1267 23.3736 17.1267 24.869C17.1267 26.3644 18.3293 27.5767 19.8126 27.5767Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2306 29.4842C7.70339 29.4842 5.65234 27.4165 5.65234 24.8688C5.65234 22.3211 7.70339 20.2534 10.2306 20.2534C12.7577 20.2534 14.8088 22.3211 14.8088 24.8688C14.8088 27.4165 12.7577 29.4842 10.2306 29.4842ZM10.2306 27.5765C11.7139 27.5765 12.9165 26.3642 12.9165 24.8688C12.9165 23.3734 11.7139 22.1611 10.2306 22.1611C8.74722 22.1611 7.54468 23.3734 7.54468 24.8688C7.54468 26.3642 8.74722 27.5765 10.2306 27.5765Z",
    fill: "#714B67"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.9614,
    r: 24,
    stroke: "#714B67"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6829_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.9077,
    height: 12.0615,
    fill: "white",
    transform: "translate(5.65234 17.4229)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdoo);
export default __webpack_public_path__ + "static/media/odoo.a95cdd0a8f1c686b2cd0b91e1d0b97dc.svg";
export { ForwardRef as ReactComponent };